class MediaFeatureSection extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const swipers = this.querySelectorAll('.media-feature__swiper');
    swipers.forEach((el) => {
      new Swiper(el, {
        slidesPerView: 1.1,
        spaceBetween: 6,
        breakpoints: {
          768: {
            slidesPerView: 1.5,
            spaceBetween: 3,
          },
        },
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (!customElements.get('media-feature-section')) {
    customElements.define('media-feature-section', MediaFeatureSection);
  }
});
